import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref } from "vue"

const _hoisted_1 = { class: "billing" }
const _hoisted_2 = { class: "billing__row" }
const _hoisted_3 = { class: "billing__control" }
const _hoisted_4 = { class: "billing__row" }
const _hoisted_5 = { class: "billing__text" }
const _hoisted_6 = {
  "data-test": "billing-hint",
  class: "billing__hint"
}
const _hoisted_7 = { class: "billing__control" }
const _hoisted_8 = {
  key: 0,
  class: "billing__select"
}
const _hoisted_9 = {
  key: 1,
  "data-test": "price-list-name"
}
const _hoisted_10 = { class: "billing__row" }
const _hoisted_11 = { class: "billing__text" }
const _hoisted_12 = {
  "data-test": "billing-hint",
  class: "billing__hint"
}
const _hoisted_13 = { class: "billing__control" }

import { computed, onMounted, ref } from 'vue'

import ManageAccountCreditModal from '@/components/customers/ManageAccountCreditModal.vue'
import ProfileTax from '@/components/customers/profile/ProfileTax.vue'
import RecordButton from '@/components/customers/record/RecordButton.vue'
import RecordCard from '@/components/customers/record/RecordCard.vue'
import SelectInput from '@/components/neue/SelectInput.vue'
import { taxStructureHint } from '@/helpers/taxStructure'
import api from '@/store/api'
import { mapRelationship, mapType } from '@/store/mappers'


export default {
  __name: 'ProfileBilling',
  props: {
  conversationUserPairId: { type: String, required: true },
  editable: { type: Boolean, default: false }
},
  setup(__props) {

const props = __props

const accountCredit = ref('')
const creditModalOpen = ref(false)

const pair = computed(() => mapRelationship({ type: 'conversation_user_pair', id: props.conversationUserPairId }))
const priceLists = computed(() => mapType('price_list'))
const priceListId = computed(() => pair.value?.relationships?.price_list?.data?.id)
const selectedPriceList = computed(() => priceLists.value.find(list => list.id === priceListId.value))
const priceListOptions = computed(() => [
  { name: '(None)', value: null },
  ...priceLists.value.map(list => ({ name: list.attributes.price_list_name, value: list.id }))
])
const priceListName = computed(() => selectedPriceList.value?.attributes.price_list_name || '(None)')
const priceListHint = computed(() =>
  selectedPriceList.value
    ? `${selectedPriceList.value.attributes.price_list_name} prices apply`
    : 'Standard prices apply'
)
const taxStructure = computed(() => pair.value?.attributes?.tax_structure ?? null)
const isZeroCredit = computed(() => !/[1-9]/.test(accountCredit.value ?? ''))

const setPriceList = id => {
  api.call('PUT', `conversation_user_pairs/${props.conversationUserPairId}?included=none`, {
    conversation_user_pair: { price_list_id: id }
  })
}

onMounted(() => {
  api.call('GET', `conversation_user_pairs/${props.conversationUserPairId}/customer`).then(response => {
    accountCredit.value = response.data.data.attributes?.account_credit?.format ?? null
  })
  api.call('GET', 'price_lists?included=none')
})

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(RecordCard, {
    "data-test": "billing-card",
    title: "Billing"
  }, {
    default: _withCtx(() => [
      _createVNode(ManageAccountCreditModal, {
        "is-open": creditModalOpen.value,
        "conversation-user-pair-id": __props.conversationUserPairId,
        onClose: _cache[0] || (_cache[0] = $event => (creditModalOpen.value = false)),
        onSuccess: _cache[1] || (_cache[1] = format => (accountCredit.value = format))
      }, null, 8, ["is-open", "conversation-user-pair-id"]),
      _createElementVNode("dl", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("dt", { class: "billing__text" }, [
            _createElementVNode("span", {
              "data-test": "billing-label",
              class: "billing__label"
            }, "Account credit"),
            _createElementVNode("span", {
              "data-test": "billing-hint",
              class: "billing__hint"
            }, "Applied automatically at checkout")
          ], -1)),
          _createElementVNode("dd", _hoisted_3, [
            _createElementVNode("span", {
              "data-test": "account-credit",
              class: _normalizeClass(["billing__credit tabular-nums", isZeroCredit.value && 'billing__credit--zero'])
            }, _toDisplayString(accountCredit.value), 3),
            (__props.editable)
              ? (_openBlock(), _createBlock(RecordButton, {
                  key: 0,
                  "data-test": "edit-credit",
                  variant: "quiet",
                  size: "sm",
                  onClick: _cache[2] || (_cache[2] = $event => (creditModalOpen.value = true))
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode(" Adjust ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("dt", _hoisted_5, [
            _cache[5] || (_cache[5] = _createElementVNode("span", {
              "data-test": "billing-label",
              class: "billing__label"
            }, "Price list", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(priceListHint.value), 1)
          ]),
          _createElementVNode("dd", _hoisted_7, [
            (__props.editable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createVNode(SelectInput, {
                    class: "w-full",
                    options: priceListOptions.value,
                    "model-value": priceListId.value,
                    "onUpdate:modelValue": setPriceList
                  }, null, 8, ["options", "model-value"])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(priceListName.value), 1))
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("dt", _hoisted_11, [
            _cache[6] || (_cache[6] = _createElementVNode("span", {
              "data-test": "billing-label",
              class: "billing__label"
            }, "Tax", -1)),
            _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(taxStructureHint)(taxStructure.value)), 1)
          ]),
          _createElementVNode("dd", _hoisted_13, [
            _createElementVNode("div", {
              class: _normalizeClass(__props.editable && 'billing__select')
            }, [
              _createVNode(ProfileTax, {
                "conversation-user-pair-id": __props.conversationUserPairId,
                editable: __props.editable
              }, null, 8, ["conversation-user-pair-id", "editable"])
            ], 2)
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

}